import { Component, inject, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-disclaimer.content.json';

@Component({
    selector: 'conversational-chat-disclaimer',
    templateUrl: './conversational-chat-disclaimer.component.html',
    standalone: false
})
export class ConversationalChatDisclaimerComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }
}
